import Styles from './PerformanceInsights.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { Spinner } from 'components/MobileAutopilotCalendar/components/MobileToast/Spinner'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'

export interface LoadingMessageProps {
  progress?: number
  label: string
}

export const LoadingMessage = ({ label, progress }: LoadingMessageProps) => (
  <div className={Styles.loading}>
    <div className={Styles.loadingWrapper}>
      <div className={Styles.loadingLabel}>
        <Spinner />
        <Text variant="primary" color="var(--dark-90)">
          {label}
        </Text>
      </div>
      <LoadingEllipses />
      {progress !== undefined && (
        <div className={Styles.loadingProgress}>
          <Text variant="primary" color="var(--dark-90)">
            {progress}%
          </Text>
        </div>
      )}
    </div>
  </div>
)
